// @flow

import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { bindActionCreators } from 'redux';
import { addBreadcrumbs, removeBreadcrumb } from 'esm-web-pro/redux/breadcrumb';
import { connect, useDispatch } from 'react-redux';
import withRouter from 'speed-js-react/src/router/withRouter';
import { APIContext } from 'speed-js-react';
import ProjectsSidePanel from 'esm-web-pro/containers/pages/projects/sidepanel/ProjectsSidePanel';
import { Route } from 'react-router';
import { Redirect } from 'react-router-dom';
import DocumentsPage from 'esm-web-pro/containers/pages/projects/document/DocumentsPage';
import StagePage from 'esm-web-pro/containers/pages/projects/stage/StagePage';
import ProjectMapObjects from 'esm-web-pro/containers/pages/projects/mapobjects/ProjectMapObjects';


type Props = {
    match: Object,
    addBreadcrumbs: (title: string, link: string) => void,
    removeBreadcrumb: (title: string) => void,
};

const messages = defineMessages({
    projects: {
        id: 'projects-label-plural',
        defaultMessage: 'Projects',
    },
});

const ProjectsPageDashboard = (props: Props) => {
    const {
        match: { params: { uuid: objectId } }, addBreadcrumbs: addBreadcrumbsAction,
        removeBreadcrumb: removeBreadcrumbAction,
    } = props;

    const { apiClient } = React.useContext(APIContext);
    const dispatch = useDispatch();
    const { formatMessage } = useIntl();

    const [project, setProject] = React.useState(null);

    const reloadProject = React.useCallback(() => {
        apiClient.resources.projects.get(objectId).then((response) => {
            setProject(response);
        });
    }, [apiClient, objectId]);

    React.useEffect(() => {
        reloadProject();
    }, [reloadProject]);

    React.useEffect(() => {
        if (project) {
            dispatch(addBreadcrumbsAction([
                {
                    title: formatMessage(messages.projects),
                    link: '/projects',
                },
                {
                    title: project.name,
                    link: `/projects/${objectId}/dashboard/stages`,
                },
            ]));
        }
        return () => {
            if (project) {
                dispatch(removeBreadcrumbAction(project.name));
                dispatch(removeBreadcrumbAction(formatMessage(messages.projects)));
            }
        };
    }, [addBreadcrumbsAction, removeBreadcrumbAction, dispatch, project, objectId, formatMessage]);

    return project && (
        <>
            <ProjectsSidePanel
                object={project}
                reload={reloadProject}
            />
            <Route
                path="/projects/:uuid/dashboard"
                exact
                render={() => <Redirect to={`/projects/${project.uuid}/dashboard/stages`} />}
            />
            <Route
                path="/projects/:uuid/dashboard/stages"
                render={() => (
                    <StagePage project={project} />
                )}
            />
            <Route
                path="/projects/:uuid/dashboard/documents"
                render={() => (
                    <DocumentsPage project={project} />
                )}
            />
            <Route
                path="/projects/:uuid/dashboard/:mapobject"
                render={() => (
                    <ProjectMapObjects project={project} />
                )}
            />
        </>
    );
};


const mapDispatchToProps = ((dispatch) => (bindActionCreators({ addBreadcrumbs, removeBreadcrumb }, dispatch)));

export default withRouter(connect(null, mapDispatchToProps)(ProjectsPageDashboard));
